import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { AgentPaneProvider } from './context/AgentPaneContext';
import { TutorialProvider } from './context/TutorialContext';
import { LayoutShell } from './components/layout/LayoutShell';
import { TutorialBubble } from './components/shared/TutorialBubble';
import { TutorialTrigger } from './components/shared/TutorialTrigger';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
// import { ServiceWorkerRegistration } from './components/shared/ServiceWorkerRegistration';
import { Home } from './routes/Home';
import { Projects } from './routes/Projects';
import { ProjectDetail } from './routes/ProjectDetail';
import { Items } from './routes/Items';
import { Photos } from './routes/Photos';
import { Marketplace } from './routes/Marketplace';
import { ItemDetail } from './routes/ItemDetail';
import { Account } from './routes/Account';
import { Users } from './routes/Users';
import { Dashboard } from './routes/Dashboard';
import { Settings } from './routes/Settings';
import MCPDebugLogger from './components/debug/MCPDebugLogger';

// Unregister any existing service worker and clear ALL caches
if ('serviceWorker' in navigator) {
  console.log('[App] Unregistering service workers...');
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister().then(() => {
        console.log('[App] Service Worker unregistered successfully');
      });
    }
  });
  
  // Clear ALL caches to ensure fresh start
  if ('caches' in window) {
    caches.keys().then(function(cacheNames) {
      return Promise.all(
        cacheNames.map(function(cacheName) {
          console.log('[App] Deleting cache:', cacheName);
          return caches.delete(cacheName);
        })
      );
    }).then(() => {
      console.log('[App] All caches cleared');
    });
  }
}

// Component to handle conditional layout
const AppContent: React.FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  console.log('[AppContent] Rendering, pathname:', location.pathname);

  if (isHomePage) {
    // Home page without layout shell (no sidebar/navigation)
    return (
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    );
  }

  // All other pages with full layout and authentication protection
  return (
    <ProtectedRoute>
      <LayoutShell>
        <TutorialTrigger />
        <Routes>
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/items" element={<Items />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/items/:id" element={<ItemDetail />} />
          <Route path="/account" element={<Account />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/users" element={<Users />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </LayoutShell>
    </ProtectedRoute>
  );
};

function App() {
  console.log('[App] Component rendering');
  
  return (
    <ThemeProvider>
      <AuthProvider>
        <AgentPaneProvider>
          <Router>
            <TutorialProvider>
              <AppContent />
              <TutorialBubble />
              <MCPDebugLogger />
              {/* <ServiceWorkerRegistration /> */}
            </TutorialProvider>
          </Router>
        </AgentPaneProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
